import { render, staticRenderFns } from "./RoomCharge.vue?vue&type=template&id=3a96d3ba&"
import script from "./RoomCharge.vue?vue&type=script&lang=js&"
export * from "./RoomCharge.vue?vue&type=script&lang=js&"
import style0 from "./RoomCharge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports